import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  "shape-rendering": "crispEdges",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M60 50h20v20H60zM120 50h20v20h-20zM40 70h120v20H40zM40 90h20v20H40zM60 90h20v20H60zM100 90h20v20h-20zM140 90h20v20h-20zM120 90h20v20h-20z\"></path><path d=\"M60 90h20v20H60zM40 110h120v20H40zM40 130h20v20H40zM80 130h40v20H80zM140 130h20v20h-20zM20 130h20v20H20zM160 130h20v20h-20z\"></path><path fill=\"var(--mc-avatar)\" d=\"M80 90h20v20H80z\"></path><path d=\"M120 90h20v20h-20z\"></path><path fill=\"var(--mc-avatar)\" d=\"M100 90h20v20h-20z\"></path><path d=\"M80 90h20v20H80z\"></path><path fill=\"var(--mc-avatar)\" d=\"M60 110h20v20H60zM120 110h20v20h-20z\"></path>", 7)
  ]))]))
}
export default { render: render }